import _ from 'lodash';
import { getRequest, postRequest } from '../../Common/network-call';
import { INSTANCE_URL } from '../../Common/constant';

export const SURVEY_LIST = 'SURVEY_LIST';
export const SELECTED_SURVEY = 'SELECTED_SURVEY';
export const SHOW_BACK_SCREEN = 'SHOW_BACK_SCREEN';

export const fetchSurvey = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  var body = {
    type: 'fetchSurveyForm',
    appuserid: session.userid,
    eventid: session.eventid
  };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('response :- ', response);
        var mandatorySurveyArr = [];
        mandatorySurveyArr = _.filter(response.response, survey => {
          if (survey.ismandatory == '1' && !survey.surveytaken) return survey;
        });
        let manSurvFirst = !_.isEmpty(mandatorySurveyArr)
          ? mandatorySurveyArr[0]
          : {};

        // ordered list by display order
        let displayOrderList = _.sortBy(response.response, 'displayorder');

        dispatch({
          type: SURVEY_LIST,
          payload: {
            resource: displayOrderList,
            count: response.count,
            mandatory: manSurvFirst
          }
        });
        dispatch(selectCurrentSurvey(manSurvFirst));
        callback({ success: 1, resource: response, mandatory: manSurvFirst });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const clearSurveyList = () => {
  return dispatch => {
    dispatch({ type: SURVEY_LIST, payload: {} });
  };
};

export const selectCurrentSurvey = value => {
  return dispatch => {
    dispatch({ type: SELECTED_SURVEY, payload: {} });
    dispatch({ type: SELECTED_SURVEY, payload: value });
  };
};

export const showBackScreen = value => {
  return dispatch => {
    dispatch({ type: SHOW_BACK_SCREEN, payload: value });
  };
};

export const saveSurvey = (session, values, callback) => {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/survey_response`;
  var body = { resource: { ...values, eventid: session.eventid } };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      data => {
        callback({ success: 1, response: data });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};
